export default () => ({
  step: 1,
  visitedStep: 1,
  scanproConfiguration: null,
  scanProChecklist: [],
  scanProCriteria: [],
  criteriaChanged: false,
  isDecoded: false,
  vin: '',
  decodedVin: null,
  isSubmodelSelected: false,
  submodels: [],
  vehicle: null,
  recommendation: null,
  safety: null,
  selectedChecklistItems: [],
  isLoading: false,
  corporateId: 49
})



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/state.js